import "./style.scss";
import { useContext, useEffect, useState } from "react";
import UserContext from "src/provider/state-manager/userProvider";
import ApiContext from "src/provider/API/call-service";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import {
  AbsoluteContainer,
  AppLabel,
  AppSpan,
  Button,
  CustomContainer,
  FlexRow,
  Form,
  FormGroup,
  FormGroupWithIcon,
  GridContainer,
  Icon,
} from "src/style";
import {
  AppCenterPopupD3,
  AuthOtpD3,
  CenterPopupHeaderD3,
  TxPinVerificationD3,
} from "src/component";
import { FiChevronDown } from "react-icons/fi";
import { RadioSelection } from "src/component";
import utility, {
  handleAmountChange,
  handleTypeNumberControl,
  moneyFormat,
} from "src/utils/utility";
import helpers from "src/utils/helpers";
import { airtimeNetworks } from "src/provider/config/constant";
import { IExpenseCategory } from "src/model";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";

export const Airtime_DataD3: React.FC<any> = ({ close }) => {
  const {
    user: { accountInfo, userInfo, accountWithBalanceDetails, dashboardData },
  } = useContext(UserContext);
  const { notifier } = useContext(VisibilityContext);
  const { API } = useContext(ApiContext);
  const {
    info: { institutionData },
  } = useContext(AppInfoContext);
  const useAirtimeAsBills = institutionData?.useAirtimeAsBills;
  const [navPosition, setNavPosition] = useState(useAirtimeAsBills ? 50 : 0);
  const [input, setInput] = useState({
    accountNumber: "",
    amount: "",
    network: "",
    dataBundle: "",
    receiverPhoneNo: userInfo?.profileInfo?.phoneNumber,
    pin: "",
    billerID: "",
    billerName: "",
    billerCategoryID: "",
    expenseCategory: "",
    billerCategoryName: "",
    paymentItemID: "",
    paymentItemCode: "",
    paymentItemName: "",
    accountTier: 0,
  });
  const [billers, setBillers] = useState<any>(null);
  const [selectedBiller, setSelectedBiller] = useState<any>(null);
  const [packages, setPackages] = useState<any>(null);
  const [selectedPackage, setSelectedPackage] = useState<any>(null);
  const [frequentAirtime, setFrequentAirtime] = useState<
    Array<number | string>
  >(["500", "1000", "1500"]);
  const [transactionReference, setTransactionReference] = useState("");
  const [phoneNoType, setPhoneNoType] = useState("Self");
  const [expenseCategories, setExpenseCategories] = useState<
    IExpenseCategory[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [view, setView] = useState("airtime_data");
  const phoneNumberLength = institutionData?.phoneNumberLength;

  console.log("phon", phoneNumberLength);

  useEffect(() => {
    handleFetchExpenseCategories();
  }, [accountWithBalanceDetails]);

  useEffect(() => {
    if (navPosition === 50 && !billers && !useAirtimeAsBills)
      handleFetchBillers();
    if (useAirtimeAsBills) handleRFSAirtimeBillers();
    if (navPosition === 0) handleFetchFrequentAirtime();
    setInput({
      ...input,
      expenseCategory: navPosition === 0 ? "Airtime" : "Data",
    });
  }, [navPosition]);

  useEffect(() => {
    if (useAirtimeAsBills && packages) {
      const firstBiller = packages[0];
      handlePackage(JSON.stringify(firstBiller));
    }
  }, [useAirtimeAsBills, packages]);

  async function handleRFSAirtimeBillers() {
    setIsLoading(true);
    const response = await API.getRFSAirtimeBillers();
    setIsLoading(false);
    if (response) setBillers(response);
  }

  async function handleFetchExpenseCategories() {
    let nuban = "";
    if (accountWithBalanceDetails?.length === 1 && accountWithBalanceDetails[0].nuban === null ){
      nuban = accountWithBalanceDetails[0].number;
    }else {
      nuban = accountWithBalanceDetails[0].nuban
    }
      

    setIsLoading(true);
    const response = expenseCategories?.length
      ? expenseCategories
      : await API.getExpenseCategories();
    setIsLoading(false);
    if (response) {
      setExpenseCategories(response);
    }
     console.log("nuban", nuban)
    setInput({
      ...input,
      accountNumber: nuban,
      expenseCategory: navPosition === 0 ? "Airtime" : "Data",
    });
  }

  async function handleFetchFrequentAirtime() {
    setIsLoading(true);
    const response = await API.getFrequentAirtime();
    setIsLoading(false);
    if (response) {
      response.sort(function (a: number, b: number) {
        return a - b;
      });
      const dataToString = response.toString();
      const dataToArray = dataToString.split(",");
      setFrequentAirtime(dataToArray);
    }
  }

  async function handleFetchBillers() {
    setIsLoading(true);
    const response = await API.getDataBundleBillers();
    setIsLoading(false);
    if (response) setBillers(response);
  }

  const handleInput = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    if (name === "receiverPhoneNo") {
      const maxLength = phoneNumberLength || 11;
      if (value.length > maxLength) return;
    }

    setInput({ ...input, [name]: value });
  };

  async function handleBillerSelection(val: string) {
    let biller = JSON.parse(val);
    setSelectedBiller(biller);
    setInput({
      ...input,
      billerID: biller.billerID,
      billerName: biller.billerName,
      amount: "",
      paymentItemID: "",
      billerCategoryID: biller.billerCategoryID,
      billerCategoryName: biller.billerCategory?.name || "Airtime and Data",
    });
    setIsLoading(true);
    const response = await API.getPaymentPlans(biller.billerID);
    setIsLoading(false);
    if (response) setPackages(response);
  }

  function handlePackage(val: any) {
    val = JSON.parse(val);
    setSelectedPackage(val);
    setInput({
      ...input,
      paymentItemID: val.itemID,
      amount: val.amount || "",
      paymentItemCode: val.code,
      paymentItemName: val.name,
    });
  }

  function handlePhoneType(type: string) {
    setPhoneNoType(type);
    let receiverPhoneNo = userInfo?.profileInfo.phoneNumber;
    if (type != "Self") receiverPhoneNo = "";
    setInput({ ...input, receiverPhoneNo });
  }

  async function handleProceed(
    e: React.FormEvent<HTMLButtonElement | HTMLFormElement>
  ) {
    e.preventDefault();
    if (navPosition === 0 && !input.network)
      return notifier.show("Kindly select a network", "Validation Response");
    // if (!helpers.validatePhoneNo(input.receiverPhoneNo)) return notifier.show('Kindly provide a valid phone number', 'Validation Response')
    setView("pin");
  }

  async function handleSubmit() {
    const payload = { ...input };
    payload.accountTier = Number(
      helpers.getAccountDetailsWithAcctNo(dashboardData, input.accountNumber)
        ?.accountBalance?.accountTier
    );
    const response =
      navPosition === 0
        ? await API.topupAirtime(payload)
        : await API.initiateBillsPayment({
            ...payload,
            customerUniqueCode: input.receiverPhoneNo,
          });

    if (response) {
      if (!response.shouldUseOtp) close();
      else {
        setTransactionReference(response.reference);
        setView("2fa-otp");
      }
    } else setView("airtime_data");
  }

  async function handleSubmitWithAuth(otp: string) {
    const payload = {
      reference: transactionReference,
      otp,
    };

    const response =
      navPosition === 0
        ? await API.submitAirtimeTopupWithAuth(payload)
        : await API.submitBillsPaymentWithAuth(payload);

    if (response) close();
    else setView("airtime_data");
  }

  return (
    <>
      {view === "airtime_data" && (
        <AppCenterPopupD3
          height="87"
          zIndex="6"
          overflow="hidden"
          close={close}
        >
          <CenterPopupHeaderD3
            title={useAirtimeAsBills ? "Airtime" : "Airtime and Data"}
            close={close}
          />
          {isLoading && (
            <AbsoluteContainer
              top="0"
              left="0"
              zIndex="3"
              width={useAirtimeAsBills ? "100" : "50"}
              sizeUnit="%"
              height="full"
            >
              <GridContainer
                height="100"
                hUnit="%"
                bgColor="rgba(255, 255, 255, 0.5)"
                radius="2"
              >
                <AppSpan
                  textSize="4"
                  color="#0D968F"
                  className="fa fa-spinner fa-spin"
                />
              </GridContainer>
            </AbsoluteContainer>
          )}
          <CustomContainer
            height="87"
            style={{ maxHeight: "105%" }}
            className="popup-content-container"
          >
            <GridContainer height="3.6" topMargin="3" bottomMargin="2.5">
              <AbsoluteContainer
                width={useAirtimeAsBills ? "100" : "50"}
                sizeUnit="%"
                top="0"
                left={useAirtimeAsBills ? "" : `${navPosition}`}
                lSizeUnit="%"
              >
                <CustomContainer
                  bgColor="#E7F6F5"
                  height="3.6"
                  radius="0.6"
                  borderBottomColor="#0D968F"
                  borderWidth="4.5"
                />
              </AbsoluteContainer>
              <FlexRow zIndex="2">
                {!useAirtimeAsBills && (
                  <AppSpan
                    color={navPosition === 0 ? "#0A756F" : "#667085"}
                    textSize="1.4"
                    cursor="pointer"
                    fontWeight="600"
                    width="50"
                    sizeUnit="%"
                    align="center"
                    onClick={() => setNavPosition(0)}
                  >
                    Airtime
                  </AppSpan>
                )}

                <AppSpan
                  color={
                    navPosition === 50 || useAirtimeAsBills
                      ? "#0A756F"
                      : "#667085"
                  }
                  textSize="1.4"
                  cursor="pointer"
                  fontWeight="600"
                  width="100"
                  sizeUnit="%"
                  align="center"
                  onClick={() => setNavPosition(50)}
                >
                  {useAirtimeAsBills ? "Airtime" : "Data"}
                </AppSpan>
              </FlexRow>
            </GridContainer>
            <Form
              onSubmit={handleProceed}
              style={{ height: "75%" }}
              className="overflow-y-container inner-scroll-container"
            >
              {navPosition === 0 && (
                <CustomContainer bottomMargin="2">
                  <AppLabel color="#1A2C37" textSize="1.4" fontWeight="600">
                    Select Network
                  </AppLabel>
                  <GridContainer
                    className="scrollable-container"
                    topMargin="0.5"
                  >
                    <FlexRow gap="2">
                      {airtimeNetworks?.map((item, index) => {
                        return (
                          <GridContainer
                            maxHeight="8"
                            height="8" //9
                            radius="0.8"
                            key={index}
                            width="7.5" //8.8
                            borderColor={
                              input.network === item.name
                                ? "#0EA59D"
                                : "#EAECF0"
                            }
                            style={{
                              borderWidth:
                                input.network === item.name ? "3px" : "1.5px",
                            }}
                            bgColor={item.bgColor}
                            onClick={() =>
                              setInput({ ...input, network: item.name })
                            }
                          >
                            <Icon height="auto" src={item.img} />
                          </GridContainer>
                        );
                      })}
                    </FlexRow>
                  </GridContainer>
                </CustomContainer>
              )}
              {navPosition === 50 && (
                <FormGroupWithIcon bottomMargin="2">
                  <label>Select Network</label>
                  <div className="input-with-icon">
                    <select
                      value={JSON.stringify(selectedBiller)}
                      style={{ color: input.billerID ? "#000000" : "#667085" }}
                      onChange={(e) => handleBillerSelection(e.target.value)}
                      //required
                    >
                      <option value="">Select Network</option>
                      {billers?.map((item: any, index: number) => {
                        return (
                          <option key={index} value={JSON.stringify(item)}>
                            {item.billerName}
                          </option>
                        );
                      })}
                    </select>
                    <FiChevronDown className="input-with-icon-tag" />
                  </div>
                </FormGroupWithIcon>
              )}
              <CustomContainer bottomMargin="1.5">
                <AppLabel fontWeight="600" color="#1A2C37" bottomMargin="1.5">
                  Recipient Phone Number
                </AppLabel>
                <RadioSelection
                  options={["Self", "Others"]}
                  output={(val: string) => handlePhoneType(val)}
                />
              </CustomContainer>
              <FormGroup>
                <input
                  placeholder="Enter Phone Number"
                  type="number"
                  name="receiverPhoneNo"
                  value={input.receiverPhoneNo}
                  onChange={handleInput}
                  onKeyDown={handleTypeNumberControl}
                  onKeyUp={handleTypeNumberControl}
                  disabled={phoneNoType === "Self" ? true : false}
                  autoComplete="off"
                  required
                />
              </FormGroup>
              {navPosition === 0 && (
                <>
                  <CustomContainer bottomMargin="1">
                    <AppLabel
                      fontWeight="600"
                      color="#1A2C37"
                      bottomMargin="1.5"
                    >
                      Frequent Airtime
                    </AppLabel>
                    <RadioSelection
                      options={frequentAirtime}
                      noDefault
                      value={amount}
                      output={(val: string) =>
                        handleAmountChange(
                          val,
                          "selection",
                          setAmount,
                          setInput,
                          input
                        )
                      }
                    />
                  </CustomContainer>
                  <FormGroup>
                    <label>Amount</label>
                    <input
                      placeholder="Enter Amount"
                      name="amount"
                      value={amount}
                      onChange={(e) =>
                        handleAmountChange(
                          e.target.value,
                          "input",
                          setAmount,
                          setInput,
                          input,
                          e.target.name
                        )
                      }
                      autoComplete="off"
                      required
                    />
                  </FormGroup>
                </>
              )}
              {!useAirtimeAsBills && navPosition === 50 && (
                <FormGroupWithIcon bottomMargin="2">
                  <label>Data Bundle</label>
                  <div className="input-with-icon">
                    <select
                      value={JSON.stringify(selectedPackage)}
                      style={{
                        color: input.paymentItemID ? "#000000" : "#667085",
                      }}
                      onChange={(e) => handlePackage(e.target.value)}
                      //required
                    >
                      <option value="">Select Package</option>
                      {packages?.map((item: any, index: number) => {
                        return (
                          <option key={index} value={JSON.stringify(item)}>
                            {item.name}
                          </option>
                        );
                      })}
                    </select>
                    <FiChevronDown className="input-with-icon-tag" />
                  </div>
                </FormGroupWithIcon>
              )}
              {navPosition === 50 && (
                <FormGroup>
                  <label>Amount</label>
                  <input
                    placeholder="Enter Amount"
                    name="amount"
                    value={amount}
                    onChange={(e) =>
                      handleAmountChange(
                        e.target.value,
                        "input",
                        setAmount,
                        setInput,
                        input,
                        e.target.name
                      )
                    }
                    disabled={selectedPackage?.amount}
                    autoComplete="off"
                    required
                  />
                </FormGroup>
              )}
              {!useAirtimeAsBills && (
                <FormGroupWithIcon bottomMargin="2">
                  <label>Expense Category</label>
                  <div className="input-with-icon">
                    <select
                      placeholder="Select Expense Category"
                      name="expenseCategory"
                      value={input.expenseCategory}
                      style={{
                        color: input.expenseCategory ? "#000000" : "#667085",
                      }}
                      onChange={handleInput}
                      disabled
                    >
                      <option value="Select">Select Category</option>
                      {expenseCategories?.map(
                        (item: IExpenseCategory, index: number) => {
                          return (
                            <option value={item.name} key={index}>
                              {item.name}
                            </option>
                          );
                        }
                      )}
                    </select>
                    <FiChevronDown className="input-with-icon-tag" />
                  </div>
                </FormGroupWithIcon>
              )}
              <FormGroupWithIcon>
                <label>Account</label>
                <div className="input-with-icon">
                  <select
                    name="accountNumber"
                    value={input.accountNumber}
                    style={{
                      color: input.accountNumber ? "#000000" : "#667085",
                    }}
                    onChange={handleInput}
                    disabled={accountWithBalanceDetails?.length === 1}
                    required
                  >
                    <option value="">Select Account</option>
                    {accountWithBalanceDetails?.map(
                      (item: any, index: number) => {
                        const accountIdentifier = item.nuban || item.number;
                        return (
                          <option
                            value={accountIdentifier}
                            key={index}
                            // disabled={item.nuban === input.accountNumber}
                          >
                            {accountIdentifier} - (
                            {moneyFormat(
                              item?.balance?.withdrawableAmount,
                              institutionData?.defaultCurrency
                            )}
                            )
                          </option>
                        );
                      }
                    )}
                  </select>
                  <FiChevronDown className="input-with-icon-tag" />
                </div>
              </FormGroupWithIcon>

              <FlexRow justifyContent="flex-end">
                <Button
                  width="100"
                  sizeUnit="%"
                  height="4.4"
                  topMargin="2.5"
                  borderColor="#0D968F"
                  hoverBgColor="#fff"
                  hoverColor="#0D968F"
                  titleSize="1.4"
                >
                  Proceed
                </Button>
              </FlexRow>
            </Form>
          </CustomContainer>
        </AppCenterPopupD3>
      )}
      {view === "pin" && (
        <TxPinVerificationD3
          close={() => setView("airtime_data")}
          onPinChange={(pin: string) => setInput({ ...input, pin })}
          next={handleSubmit}
        />
      )}
      {view === "2fa-otp" && (
        <AuthOtpD3 close={close} next={handleSubmitWithAuth} />
      )}
    </>
  );
};
